import React, { useState, useEffect } from "react";
import { Snackbar, Alert, AlertColor } from "@mui/material";

interface CustomAlertProps {
	severity: AlertColor;
	message: string;
}

const CustomAlert: React.FC<CustomAlertProps> = ({ severity, message }) => {
	const [open, setOpen] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => setOpen(false), 5000);
		return () => clearTimeout(timer);
	}, []);

	const handleClose = (
		_event?: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") return;
		setOpen(false);
	};

	return (
		<Snackbar
			open={open}
			autoHideDuration={5000}
			onClose={handleClose}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
		>
			<Alert
				onClose={handleClose}
				severity={severity}
				sx={{ width: "100%" }}
				variant="filled"
			>
				{message}
			</Alert>
		</Snackbar>
	);
};

export default CustomAlert;
